import { AfterSubmitFunc, FormTemplate, TextInput } from 'ui-builder';
import { StateDropdown } from 'features/tasks-forms';
import React from 'react';
import { Separator } from 'features/nekst-widgets';
import DetailsFieldsSetDropdowns from './DetailsFieldsSetDropdowns';
import { useMarketsAdminService } from 'nekst-api';
import { TeamIdInput } from './TeamAutocompleteInput';

type FormDataType = {
  name: string,
  alias: string,
  version: string,
  state: string,
  description: string,
  teamId: number,
  listingSetId?: number,
  pendingBuyerSetId?: number,
  pendingSellerSetId?: number,
  pendingDualSetId?: number,
  otherSetId?: number,
  activeBuyerSetId?: number,
}

export default function CreateMarketBasedOnTeamDataForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {

  const marketsAdminService = useMarketsAdminService();

  return (
    <FormTemplate<FormDataType>
      title="Create Market Based on Team Data"
      submitFormFunc={async (data) => {
        await marketsAdminService.buildMarketBasedOnTeamData({
          name: data.name,
          alias: data.alias,
          state: data.state,
          description: data.description,
          teamId: data.teamId,
          version: data.version,
          setsIds: [
            data.listingSetId,
            data.pendingBuyerSetId,
            data.pendingSellerSetId,
            data.pendingDualSetId,
            data.otherSetId,
            data.activeBuyerSetId
          ].filter((id) => !!id) as number[],
        })

        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        alias: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 30,
            regex: {
              value: /^[a-zA-Z0-9\\-]+$/,
              message: 'Alias must start with a letter and can only contain letters and numbers.'
            }
          }
        },
        version: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 12,
            regex: {
              value: /^[a-zA-Z0-9\\-]+$/,
              message: 'Alias must start with a letter and can only contain letters and numbers.'
            }
          }
        },
        state: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        description: {
          type: 'string',
          constraints: {
            required: false
          }
        },
        teamId: {
          type: 'int',
          constraints: {
            required: true,
          }
        }
      }}
    >
      <TeamIdInput source="teamId" label="Team Owner" />
      <DetailsFieldsSetDropdowns />
      <Separator />

      <TextInput source="name" label="Market Name" />
      <TextInput source="alias" label="Alias" />
      <TextInput source="version" label="Version" />
      <StateDropdown source="state" label="State" />
    </FormTemplate>
  );
}
